const isNative = () => Boolean(window.Capacitor?.isNativePlatform());

let _haptics = null;
const getHaptics = async () => {
  if (!isNative()) return null;
  if (!_haptics) {
    const mod = await import('@capacitor/haptics');
    _haptics = mod;
  }
  return _haptics;
};

export const hapticLight = async () => {
  const h = await getHaptics();
  if (!h) return;
  await h.Haptics.impact({ style: h.ImpactStyle.Light }).catch(() => {});
};

export const hapticMedium = async () => {
  const h = await getHaptics();
  if (!h) return;
  await h.Haptics.impact({ style: h.ImpactStyle.Medium }).catch(() => {});
};

export const hapticSuccess = async () => {
  const h = await getHaptics();
  if (!h) return;
  await h.Haptics.notification({ type: h.NotificationType.Success }).catch(() => {});
};

export const hapticError = async () => {
  const h = await getHaptics();
  if (!h) return;
  await h.Haptics.notification({ type: h.NotificationType.Error }).catch(() => {});
};
